import React from 'react';
import { Paper } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Renders a customized input text component based on the provided personalized text.
 * If the personalized text is not provided or empty, returns null.
 * Displays the title and body text in a Paper component with specific styling.
 * @param {Object} personalizedText - An object containing the title and body text to display.
 * @returns {JSX.Element | null} The customized input text component or null if no text provided.
 */
const CustomizedInputText = ({ personalizedText }) => {
  if (!personalizedText) return null;
  return (
    <Paper
      sx={{ padding: 2, backgroundColor: '#f9f9f9' }}
      dangerouslySetInnerHTML={{ __html: personalizedText }}
    />
  );
};

CustomizedInputText.propTypes = {
  personalizedText: PropTypes.object.isRequired,
};
export default CustomizedInputText;
